module.exports = __webpack_public_path__ + "img/google-btn-mb.8cc68a55.svg";